import React from 'react';
import { connect } from 'react-redux';
import { Table } from 'semantic-ui-react';
import { columnCode, columnName } from '@/constants/fields';
import { states } from '@/constants/lifecycle';
import TableWrapper from '@/components/table/TableWrapper';
import ActionDialogContent from '@/components/dialogs/ActionDialogContent';
import { deleteSearch, hideDeleteSearch } from '../actions';
import SearchesTableColumns from './SearchesTableColumns';
import SearchesTableRows from '../components/SearchesTableRows';

const SearchDeletionDialog = ({
  deleteData,
  hide,
  results,
  theme,
}) => (
  <ActionDialogContent
    inProgress={results.some((result) => result.destroyStatus === states.PENDING)}
    items={results}
    hide={hide}
    theme={theme}
    onSubmit={deleteData}
    entity="search"
    entities="searches"
    className="aridhia-search-deletion-dialog"
    icon="search"
  >
    <div className="aridhia-dialog-table-container">
      <TableWrapper sticky celled className="aridhia-Searches-table">
        <Table.Header fullWidth>
          <SearchesTableColumns items={results} columns={[columnName, columnCode]} />
        </Table.Header>
        <Table.Body>
          <SearchesTableRows items={results} columns={[columnName, columnCode]} />
        </Table.Body>
      </TableWrapper>
    </div>
  </ActionDialogContent>
);

const mapStateToProps = ({
  search: { searches: { deletion: { results } } },
}) => ({
  results,
});

const mapDispatchToProps = {
  hide: hideDeleteSearch,
  deleteData: deleteSearch,
};

export default connect(mapStateToProps, mapDispatchToProps)(SearchDeletionDialog);
